import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'

interface IFeaturesSectionProps {
    title: string;
    textArray: Array<string>;
}

const FeaturesSectionYeah = ({ title, textArray }: IFeaturesSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_px80}`}>
            <div className={`${style.container} ${style.features}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.title} ${style.title_large} ${style.features__title} ${style.mr106} ${animations.scroll__animation}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${style.features__items}`}>
                    {
                        textArray.map((text: string, index: number) => {
                            return (
                                <InView triggerOnce={true} key={index}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry?.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${style.features__item} ${style.text} ${animations.scroll__animation} ${style.text_middle}`}>
                                                {text}
                                            </div>
                                        )
                                    }}
                                </InView>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default FeaturesSectionYeah;